<div class="col-12 flex flex-wrap developer centerWidth">
    <div class="lg:col-6 md:col-12 sm:col-12">
        <img style="width: 100%;" *ngIf="developerBar!=null  && developerBar['img-uid']!=null"
             [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +developerBar['img-uid'] ">
    </div>
    <div class="lg:col-6 md:col-12 sm:col-12" style="margin: auto;">
        <h2>{{developerBar!=null ? developerBar['title'] :''}}</h2>
        <p>{{developerBar != null ? developerBar['text']:''}}</p>
        <div class="more-div" >
            <a target="_blank" *ngIf="developerBar!= null && developerBar['url']!=null" [href]="developerBar!= null ? developerBar['url']:'#'">
                <div class="more-btn"  >
                    <span i18n="@@See more">See more</span>
                    <i *ngIf="getDirection()=='rtl'" class="pi pi-angle-left"></i>
                    <i *ngIf="getDirection()=='ltr'" class="pi pi-angle-right"></i>
                </div>
            </a>
        </div>
    </div>
</div>